import React from 'react';
import NumberComponent from '../Number';
import { setAttribute } from '../shared/setAttribute';
import SvgComponent from '../SvgComponent';

/**
 * Wraps a Number component and adds the dollar icon. This is meant mostly for UI purposes. This can be a drop-in
 * replacement for any current field being used for currency purposes. This simply just passes down the props.
 */
export default class Currency extends React.Component {
  constructor(props) {
    super(props);
    this.handleError = this.handleError.bind(this);
  }

  handleError(value, arr) {
    const arr2 = arr.map((err) => ({
      code: `currency.${err.code}`,
      valid: err.valid,
      uid: err.uid,
    }));

    return this.props.onError(value, arr2);
  }

  render() {
    return (
      <div className="currency">
        <div className="dollar-sign">
          <SvgComponent className="dollar-sign" src="/img/dollar-sign.svg" />
        </div>
        <div className="number">
          <NumberComponent
            {...this.props}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            attribute={setAttribute(this.props.attribute, 'value')}
            maxlength={this.props.maxlength}
          />
        </div>
      </div>
    );
  }
}

Currency.defaultProps = {
  name: 'currency',
  disabled: false,
  value: '',
  min: '1',
  max: '2147483647',
  maxlength: '10',
  onError: (value, arr) => arr,
};

Currency.errors = [];
